import { API } from "../../constants";
import { ApiResponse } from "../../types";
import { apiSlice } from "../api-slice";
import { Series } from "./types";

const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAllSeriesNames: build.query<string[], void>({
      query: () => `${API}/series/allactivebyplays`,
      transformResponse: (response: ApiResponse<string[]>) => response.data,
    }),
    getAllSeries: build.query<Series[], void>({
      query: () => `${API}/series/allactive`,
      transformResponse: (response: ApiResponse<Series[]>) => response.data,
      providesTags: ["Series"],
    }),
    createSeries: build.mutation<ApiResponse<Series>, { name: string }>({
      query: (series) => ({ method: "POST", url: `${API}/series`, body: series }),
      invalidatesTags: ["Series"],
    }),
    deleteSeries: build.mutation<ApiResponse<Series>, { id: string }>({
      query: (series) => ({ method: "DELETE", url: `${API}/series/${series.id}` }),
      invalidatesTags: ["Series"],
    }),
    editSeries: build.mutation<ApiResponse<Series>, { id: string; series_id: string; name: string }>({
      query: ({ id, series_id, name }) => ({ method: "POST", url: `${API}/series`, body: { name, id, series_id } }),
      invalidatesTags: ["Series"],
    }),
  }),
});

export const {
  useGetAllSeriesNamesQuery,
  useLazyGetAllSeriesNamesQuery,
  useGetAllSeriesQuery,
  useLazyGetAllSeriesQuery,
  useCreateSeriesMutation,
  useDeleteSeriesMutation,
  useEditSeriesMutation,
} = extendedApiSlice;
